import { APP_URL } from "../../config";

export const getAppUrl = path => {
  return `${APP_URL}${path}`;
};
